import React, { useState, useEffect } from "react";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { useTranslation } from "react-i18next";
import { Spinner } from "react-bootstrap";
import { BasicColor } from "../../Utils/constants";

const VideoGallery = ({ divTitle }) => {
  const { t, i18n } = useTranslation();
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const db = getFirestore();

  // Fetch videos from Firestore
  useEffect(() => {
    const fetchVideos = async () => {
      setLoading(true);
      try {
        const snapshot = await getDocs(collection(db, "ytVideos"));
        const fetchedVideos = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // Sort videos by the "order" field in ascending order
        const sortedVideos = fetchedVideos.sort((a, b) => a.order - b.order);

        setVideos(sortedVideos);
      } catch (error) {
        console.error("Error fetching videos:", error);
      }
      setLoading(false);
    };

    fetchVideos();
  }, [db]);

  return (
    <div style={{ marginTop: "10px", marginBottom: "10px" }}>
      <div
        style={{
          textAlign: `${i18n.dir() === "ltr" ? "left" : "right"}`,
          fontWeight: "bold",
          color: BasicColor,
        }}
      >
        <h4>{divTitle}</h4>
      </div>

      {loading ? (
        <Spinner animation="border" className="d-block mx-auto" />
      ) : (
        <div style={styles.container}>
          {videos.map((video, index) => {
            const videoId = video.url.split("/").pop().split("?")[0]; // Extract the video ID
            const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`; // Construct thumbnail URL

            return (
              <div key={index} style={styles.card}>
                <a href={video.url} target="_blank" rel="noopener noreferrer">
                  <img
                    src={thumbnailUrl}
                    alt={video.title}
                    style={styles.thumbnail}
                  />
                </a>
                <VideoTitle title={video.title} maxLength={30} />
                <VideoSubtitle subtitle={video.subtitle} maxLength={50} />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

const VideoTitle = ({ title, maxLength }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const truncatedTitle =
    title.length > maxLength ? title.slice(0, maxLength) + "..." : title;

  return (
    <h3>
      {isExpanded ? title : truncatedTitle}
      {title.length > maxLength && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          style={styles.moreButton}
        >
          {isExpanded ? "Less" : "More"}
        </button>
      )}
    </h3>
  );
};

const VideoSubtitle = ({ subtitle, maxLength }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const truncatedSubtitle =
    subtitle.length > maxLength
      ? subtitle.slice(0, maxLength) + "..."
      : subtitle;

  return (
    <p>
      {isExpanded ? subtitle : truncatedSubtitle}
      {subtitle.length > maxLength && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          style={styles.moreButton}
        >
          {isExpanded ? "Less" : "More"}
        </button>
      )}
    </p>
  );
};

const styles = {
  container: {
    display: "flex",
    overflowX: "auto",
    padding: "10px",
    gap: "10px",
  },
  card: {
    minWidth: "200px",
    maxWidth: "30%",
    border: "1px solid #ccc",
    borderRadius: "8px",
    padding: "10px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
  },
  thumbnail: {
    width: "100%",
    borderRadius: "8px",
  },
  moreButton: {
    backgroundColor: "transparent",
    border: "none",
    color: BasicColor,
    cursor: "pointer",
    fontSize: "0.9rem",
    fontWeight: "bold",
    marginLeft: "5px",
  },
};

export default VideoGallery;
